import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Automations from './private/Automations/Automations';
import AutomationStatus from './private/Automations/AutomationStatus';
import NewLaunch from './private/Automations/LaunchAutomation/NewLaunch';
import Backtests from './private/Automations/Backtests/Backtests';
import NewBacktest from './private/Automations/Backtests/NewBacktest';
import BacktestDetails from './private/Automations/Backtests/BacktestDetails';
import Dashboard from './private/Dashboard/Dashboard';
import NewOrder from './private/Futures/NewOrder';
import Monitors from './private/Monitors/Monitors';
import MonitorStatus from './private/Monitors/MonitorStatus';
import Onboarding from './private/Onboarding/Onboarding';
import Faq from './private/Faq/Faq';
import Orders from './private/Orders/Orders';
import NewOrderTemplate from './private/OrderTemplates/NewOrderTemplate';
import OrderTemplates from './private/OrderTemplates/OrderTemplates';
import Reports from './private/Reports/Reports';
import Settings from './private/Settings/Settings';
import Strategies from './private/Strategies/Strategies';
import Symbols from './private/Symbols/Symbols';
import WalletFull from './private/WalletFull/WalletFull';
import WebHooks from './private/WebHooks/WebHooks';
import WithdrawTemplates from './private/WithdrawTemplates/WithdrawTemplates';
import Login from './public/Login/Login';
import { getToken } from './services/tokenStore';
import UpgradeRequest from './public/UpgradeRequest/UpgradeRequest';
import ForgotPassword from './public/ForgotPassword/ForgotPassword';
import NotFound from './public/NotFound/NotFound';

function Router() {
    function PrivateRoute({ children }) {
        const isAuth = getToken() !== null;
        return isAuth ? children : <Navigate to="/" />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Login />} />
                <Route path="/upgrade" element={<UpgradeRequest />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                    path="/settings"
                    element={
                        <PrivateRoute>
                            <Settings />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/orders/:symbol?"
                    element={
                        <PrivateRoute>
                            <Orders />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/forders/:symbol?"
                    element={
                        <PrivateRoute>
                            <Orders />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/monitors"
                    element={
                        <PrivateRoute>
                            <Monitors />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/monitors/:id"
                    element={
                        <PrivateRoute>
                            <MonitorStatus />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/automations/launch/:id?"
                    element={
                        <PrivateRoute>
                            <NewLaunch />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/automations/backtests/new"
                    element={
                        <PrivateRoute>
                            <NewBacktest />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/automations/backtests/:id"
                    element={
                        <PrivateRoute>
                            <BacktestDetails />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/automations/backtests"
                    element={
                        <PrivateRoute>
                            <Backtests />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/automations/:id"
                    element={
                        <PrivateRoute>
                            <AutomationStatus />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/automations"
                    element={
                        <PrivateRoute>
                            <Automations />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/reports"
                    element={
                        <PrivateRoute>
                            <Reports />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/freports"
                    element={
                        <PrivateRoute>
                            <Reports />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/symbols"
                    element={
                        <PrivateRoute>
                            <Symbols />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/orderTemplates/:symbol?"
                    element={
                        <PrivateRoute>
                            <OrderTemplates />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/fOrderTemplates/:symbol?"
                    element={
                        <PrivateRoute>
                            <OrderTemplates />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/orderTemplate/:orderTemplateId?"
                    element={
                        <PrivateRoute>
                            <NewOrderTemplate />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/withdrawTemplates/:coin?"
                    element={
                        <PrivateRoute>
                            <WithdrawTemplates />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/wallet"
                    element={
                        <PrivateRoute>
                            <WalletFull />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/webhooks"
                    element={
                        <PrivateRoute>
                            <WebHooks />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/strategies"
                    element={
                        <PrivateRoute>
                            <Strategies />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/futures"
                    element={
                        <PrivateRoute>
                            <NewOrder />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/onboarding"
                    element={
                        <PrivateRoute>
                            <Onboarding />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/faq"
                    element={
                        <PrivateRoute>
                            <Faq />
                        </PrivateRoute>
                    }
                />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default Router;
